import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-search-customer',
  templateUrl: './search-customer.component.html',
  styleUrls: ['./search-customer.component.css']
})
export class SearchCustomerComponent implements OnInit {

  private dp = [];
  displayedColumns = ['customer_no', 'customer_name', 'customer_name_en', 'city_name', 'mobile', 'tax_no', 
    'choose'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'customer', 'customer_name': '', 'customer_no': '', 'mobile': '', 'phone1': '', 
    'tax_no': '' };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<SearchCustomerComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
  }

  search() {

    let condition = "";

    if (this.model['customer_name'] != '')
      condition = " AND (`customer`.`customer_name` LIKE '%" + this.model['customer_name'] +
        "%' OR `customer`.`customer_name_en` LIKE '%" + this.model['customer_name'] + "%')";

    if (this.model['customer_no'] != '')
      condition += " AND `customer`.`customer_no` LIKE '%" + this.model['customer_no'] + "%'";

    if (this.model['mobile'] != '')
      condition += " AND `customer`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.model['phone1'] != '')
      condition += " AND (`customer`.`phone1` LIKE '%" + this.model['phone1'] + "%' OR `customer`.`phone2` LIKE '%" + this.model['phone1'] + "%')";

    if (this.model['tax_no'] != '')
      condition += " AND `customer`.`tax_no` LIKE '%" + this.model['tax_no'] + "%'";

    let query = "SELECT `customer`.*, `city`.`city_name`, `country`.`country_id` FROM `customer`, `city`, `country` WHERE `customer`.`city_id` = `city`.`city_id`"
      + condition + " AND `city`.`country_id` = `country`.`country_id` AND `customer`.`status` = '1'";

    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
    this.model = { 'table_name': 'customer', 'customer_name': '', 'customer_no': '', 'mobile': '', 'phone1': '', 'tax_no': '' };

  }

  chooseCust(row) {
    this.dialog_data = {
      'customer_name': row.customer_name,
      'customer_id': row.customer_id,
      'customer_no': row.customer_no,
      'mobile': row.mobile
    };
    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
